import React from "react"

import CouponForm from "./CouponForm"
import PaymentTypeSelector from "./PaymentTypeSelector"

export default function PaymentDetailsForm(props) {
  return (
    <div className="payment-details-form order-step">
      <h4>{I18n.t("payment")}</h4>

      <PaymentTypeSelector
        userAuthToken={props.userAuthToken}
        venueAcceptsStripe={props.venueAcceptsStripe}
        venueAcceptsCash={props.venueAcceptsCash}
        showStripeMethod={props.showStripeMethod}
        amount={props.amount}
        currency={props.currency}
        deliveryPrice={props.deliveryPrice}
        showAlertMessage={props.showAlertMessage}
        isTakeAway={props.isTakeAway}
        errors={props.errors}
        cartState={props.cartState}
        dispatchCartState={props.dispatchCartState}
        stripe_key={props.stripe_key}
      />

      <CouponForm
        userAuthToken={props.userAuthToken}
        deliveryZone={props.deliveryZone}
        venueId={props.venueId}
        acceptsCoupons={props.acceptsCoupons}
        availableCoupons={props.availableCoupons}
        startTime={props.startTime}
        initialErrors={props.errors}
        cartState={props.cartState}
        dispatchCartState={props.dispatchCartState}
      />
    </div>
  )
}
